export default __webpack_public_path__ + "static/media/IE.fd330934.svg";